<template>
  <div>
    <v-alert v-if="errors.length" type="error" class="ma-4" dismissible @input="clearErrors">
      <div v-for="(error, i) in errors" :key="i">{{ error }}</div>
    </v-alert>

    <v-alert v-if="successes.length" type="success" class="ma-4" dismissible @input="clearSuccesses">
      <div v-for="(success, i) in successes" :key="i">{{ success }}</div>
    </v-alert>
    <iframe :src="helloUrl" style="width: 100%; height: 70vh;"></iframe>
  </div>
</template>

<script>

import { EventBus } from '../../../mixins';

export default {
  name: 'ProfileInteractions',
  beforeRouteLeave (to, from, next) {
    next();
  },
  beforeRouteEnter (to, from, next) {
    next(() => {
    });
  },
  beforeRouteUpdate (to, from, next) {
    next();
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    errors: {
      type: Array,
      default: () => []
    },
    successes: {
      type: Array,
      default: () => []
    },
    content: {
      type: Object,
      default: null
    }
  },
  data () {
    return ({ });
  },
  computed: {
    isProd () {
      return process.env.VUE_APP_ENVIRONMENT === 'production';
    },
    helloUrl () {
      const baseUrl = this.$store.state.brand === 'crm_labalaguere' ? process.env.VUE_APP_HELLO_CHAT_LB : process.env.VUE_APP_HELLO_CHAT_SB;
      return `${baseUrl}/userInteraction/${this.content.uuid}/?token=${this.$store.state.token}`;
    }
  },
  mounted () {
  },
  created () {

  },
  methods: {
    clearErrors () {
      EventBus.$emit('change-errors', []);
    },
    clearSuccesses () {
      EventBus.$emit('change-successes', []);
    }
  }
};
</script>
